<template>
  <a-layout-content style="padding: 0 250px">
    <h2 style="text-align: center">欢迎</h2>
  </a-layout-content>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

// import axios from 'axios';


export default defineComponent({
  components: {
  },
  name: 'Home',
  setup() {


    // onMounted(() => {
    //   console.log()
    // });

    return {};
  },
});
</script>

<style scoped>
</style>
